/* eslint-disable import/prefer-default-export */
export const tryParse = data => {
  try {
    return JSON.parse(data);
  } catch {
    return data;
  }
};

/**
 * Safely parses artwork URLs JSON and extracts the last URL and artwork IDs
 * @param {string} artworkUrlsJson - JSON string containing artwork URLs
 * @returns {Object|null} - Object with imageUrl, artworkIds, and lastArtworkId or null if invalid
 */
export const parseArtworkUrls = artworkUrlsJson => {
  if (!artworkUrlsJson) return null;

  try {
    const urlsObj = JSON.parse(artworkUrlsJson);

    // Validate it's an object
    if (!urlsObj || typeof urlsObj !== "object") {
      return null;
    }

    // Extract artwork IDs
    const artworkIds = Object.keys(urlsObj);
    if (!Array.isArray(artworkIds) || artworkIds.length === 0) {
      return null;
    }

    // Extract URL values
    const urlValues = Object.values(urlsObj);
    if (!Array.isArray(urlValues) || urlValues.length === 0) {
      return null;
    }

    // Get the last URL
    const imageUrl = urlValues[urlValues.length - 1];
    if (!imageUrl || typeof imageUrl !== "string") {
      return null;
    }

    // Get the last artwork ID
    const lastArtworkId = artworkIds[artworkIds.length - 1];

    return {
      imageUrl,
      artworkIds,
      lastArtworkId,
      urlsObject: urlsObj
    };
  } catch (error) {
    return null;
  }
};

/**
 * Safely parses a JSON array of IDs
 * @param {string} idsJson - JSON string containing an array of IDs
 * @returns {Array|null} - Array of IDs or null if invalid
 */
export const parseJsonArray = idsJson => {
  if (!idsJson) return null;

  try {
    const parsed = JSON.parse(idsJson);
    if (!Array.isArray(parsed)) {
      return null;
    }
    return parsed;
  } catch (error) {
    return null;
  }
};
/* eslint-enable import/prefer-default-export */
